export const splitName = (input: string) => {
  const separator = input.includes('-') ? '-' : '_' // Check for the separator
  const [firstHalf, secondHalf] = input.split(separator)

  return {
    firstHalf: firstHalf.trim(),
    secondHalf: secondHalf.trim(),
  }
}

export const getFieldType = (field_type: string) => {
  return field_type
    ? field_type?.toLowerCase() === 'request.body' || field_type === 'body'
      ? 'body'
      : field_type?.toLowerCase() === 'request.pathparam' || field_type === 'params'
        ? 'params'
        : 'query'
    : ''
}
